<template>
  <div style="display: flex">
    <!--    To turn off autocomplete when otp-input is password-->
    <!-- <input
      v-if="inputType === 'password'"
      autocomplete="off"
      name="hidden"
      type="text"
      style="display: none"
    />
    <SingleOtpInput
      v-for="(item, i) in numInputs"
      :key="i"
      :focus="activeInput === i"
      :value="otp[i]"
      :separator="separator"
      :input-type="inputType"
      :input-classes="inputClasses"
      :input-mode="inputMode"
      :is-last-child="i === numInputs - 1"
      :should-auto-focus="shouldAutoFocus"
      @on-change="handleOnChange"
      @on-keydown="handleOnKeyDown"
      @on-paste="handleOnPaste"
      @on-focus="handleOnFocus(i)"
      @on-blur="handleOnBlur"
    /> -->

    <!-- NOTE: on-change: that single is already complete -->
    <SingleOtpInput
      :key="otp0Key"
      class="date-input"
      :focus="activeInput === 0"
      :value="otp[0]"
      :separator="'/'"
      :input-length="2"
      :input-type="inputType"
      :input-classes="inputClasses"
      :input-mode="inputMode"
      :is-last-child="false"
      :should-auto-focus="shouldAutoFocus"
      :disabled="disabled"
      @on-change="handleOnChange"
      @on-keydown="handleOnKeyDown"
      @on-paste="handleOnPaste"
      @on-focus="handleOnFocus(0)"
      @on-blur="handleOnBlur"
    />
    <SingleOtpInput
      :key="otp1Key"
      class="month-input"
      :focus="activeInput === 1"
      :value="otp[1]"
      :separator="'/'"
      :input-length="2"
      :input-type="inputType"
      :input-classes="inputClasses"
      :input-mode="inputMode"
      :is-last-child="false"
      :should-auto-focus="shouldAutoFocus"
      :disabled="disabled"
      @on-change="handleOnChange"
      @on-keydown="handleOnKeyDown"
      @on-paste="handleOnPaste"
      @on-focus="handleOnFocus(1)"
      @on-blur="handleOnBlur"
    />
    <SingleOtpInput
      :key="otp2Key"
      class="year-input"
      :focus="activeInput === 2"
      :value="otp[2]"
      :input-length="4"
      :input-type="inputType"
      :input-classes="inputClasses"
      :input-mode="inputMode"
      :is-last-child="false"
      :should-auto-focus="shouldAutoFocus"
      :disabled="disabled"
      @on-change="handleOnChange"
      @on-keydown="handleOnKeyDown"
      @on-paste="handleOnPaste"
      @on-focus="handleOnFocus(2)"
      @on-blur="handleOnBlur"
    />
    <!-- Time -->
    <SingleOtpInput
      v-if="numInputs === 5"
      :key="otp3Key"
      class="hour-input"
      :focus="activeInput === 3"
      :value="otp[3]"
      :separator="':'"
      :input-length="2"
      :input-type="inputType"
      :input-classes="inputClasses"
      :input-mode="inputMode"
      :is-last-child="false"
      :should-auto-focus="shouldAutoFocus"
      :disabled="disabled"
      @on-change="handleOnChange"
      @on-keydown="handleOnKeyDown"
      @on-paste="handleOnPaste"
      @on-focus="handleOnFocus(3)"
      @on-blur="handleOnBlur"
    />
    <SingleOtpInput
      v-if="numInputs === 5"
      :key="otp4Key"
      class="minute-input"
      :focus="activeInput === 4"
      :value="otp[4]"
      :input-length="2"
      :input-type="inputType"
      :input-classes="inputClasses"
      :input-mode="inputMode"
      :is-last-child="false"
      :should-auto-focus="shouldAutoFocus"
      :disabled="disabled"
      @on-change="handleOnChange"
      @on-keydown="handleOnKeyDown"
      @on-paste="handleOnPaste"
      @on-focus="handleOnFocus(4)"
      @on-blur="handleOnBlur"
    />
  </div>
</template>

<script>
/* eslint-disable */
import dayjs from 'dayjs'
import SingleOtpInput from './SingleOtpInput.vue'
import { paddingZero } from '@/utils/dataHandler'

// keyCode constants
const BACKSPACE = 8
// const LEFT_ARROW = 37
// const RIGHT_ARROW = 39
// const DELETE = 46

export default {
  name: 'OtpInput',
  components: {
    SingleOtpInput
  },
  props: {
    value: {
      type: String
    },
    numInputs: {
      default: 3 // number of input boxes
    },
    separator: {
      type: String,
      default: '/'
    },
    inputClasses: {
      type: String
    },
    inputType: {
      type: String,
      validator(value) {
        return ['number', 'tel', 'password'].includes(value)
      }
    },
    inputMode: {
      type: String,
      validator(value) {
        return ['text', 'numeric', 'tel', 'none'].includes(value)
      }
    },
    shouldAutoFocus: {
      type: Boolean,
      default: false
    },
    minMax: {
      type: Object,
      default: () => ({ min: null, max: null })
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeInput: 0,
      otp: [],
      oldOtp: [],

      otp0Key: 0,
      otp1Key: 100,
      otp2Key: 200,
      otp3Key: 300,
      otp4Key: 400
    }
  },

  watch: {
    value: {
      handler(nv, ov) {
        if (nv && nv !== 'Invalid Date') {
          this.otp = []
          const formatted = dayjs(nv, 'YYYY-MM-DD HH:mm')
          this.otp = [
            paddingZero(formatted.get('D'), 'D'),
            paddingZero(formatted.get('M') + 1, 'M'),
            paddingZero(formatted.get('y'), 'y')
          ]
          if (this.numInputs === 5) {
            this.otp.push(
              paddingZero(formatted.get('h'), 'h'),
              paddingZero(formatted.get('m'), 'm')
            )
          }
        } else {
          this.otp = []
        }
        // re render
        this.otp0Key++
        this.otp1Key++
        this.otp2Key++
        this.otp3Key++
        this.otp4Key++

        this.checkFilledAllInputs()
      }
    }
  },

  mounted() {
    if (this.value && this.value !== 'Invalid Date') {
      const formatted = dayjs(this.value, 'YYYY-MM-DD HH:mm')
      this.otp = [
        paddingZero(formatted.get('D'), 'D'),
        paddingZero(formatted.get('M') + 1, 'M'),
        paddingZero(formatted.get('y'), 'y')
      ]
      if (this.numInputs === 5) {
        this.otp.push(
          paddingZero(formatted.get('h'), 'h'),
          paddingZero(formatted.get('m'), 'm')
        )
      }
    }
    // this.checkFilledAllInputs()
  },

  methods: {
    // validate min-max date
    validMinMax(completeDate) {
      if (this.numInputs === 5) {
        if (
          this.minMax.min &&
          dayjs(completeDate, 'DD-MM-YYYY HH:mm').isBefore(
            dayjs(this.minMax.min),
            'day'
          )
        ) {
          const min = dayjs(this.minMax.min)
          this.otp = [
            min.get('D'),
            min.get('M') + 1,
            min.get('y'),
            min.get('h'),
            min.get('m')
          ]
          return min.format('DD-MM-YYYY HH:mm')
        }
      } else {
        if (
          this.minMax.min &&
          dayjs(completeDate, 'DD-MM-YYYY').isBefore(
            dayjs(this.minMax.min),
            'day'
          )
        ) {
          const min = dayjs(this.minMax.min)
          this.otp = [min.get('D'), min.get('M') + 1, min.get('y')]
          return min.format('DD-MM-YYYY')
        }
      }

      if (this.numInputs === 5) {
        if (
          this.minMax.max &&
          dayjs(completeDate, 'DD-MM-YYYY HH:mm').isAfter(
            dayjs(this.minMax.max),
            'day'
          )
        ) {
          const max = dayjs(this.minMax.max)
          this.otp = [
            max.get('D'),
            max.get('M') + 1,
            max.get('y'),
            max.get('h'),
            max.get('m')
          ]
          return max.format('DD-MM-YYYY HH:mm')
        }
      } else {
        if (
          this.minMax.max &&
          dayjs(completeDate, 'DD-MM-YYYY').isAfter(
            dayjs(this.minMax.max),
            'day'
          )
        ) {
          const max = dayjs(this.minMax.max)
          this.otp = [max.get('D'), max.get('M') + 1, max.get('y')]
          return max.format('DD-MM-YYYY')
        }
      }
      return completeDate
    },

    // Helper to return OTP from input
    checkFilledAllInputs() {
      let allInputDirty = true
      for (const i of this.otp) {
        if (!i) {
          allInputDirty = false
          break
        }
      }
      if (allInputDirty && this.otp.length === this.numInputs) {
        const result = this.validMinMax(
          this.numInputs === 5
            ? `${this.otp.slice(0, 3).join('-')} ${this.otp
                .slice(3, 5)
                .join(':')}`
            : `${this.otp.slice(0, 3).join('-')}`
        )
        return this.$emit('on-complete', result)
      }
      return 'Wait until the user enters the required number of characters'
    },
    // Focus on input by index
    focusInput(input) {
      this.activeInput = Math.max(Math.min(this.numInputs - 1, input), 0)
    },
    // Focus on next input
    focusNextInput() {
      this.focusInput(this.activeInput + 1)
    },
    // Focus on previous input
    focusPrevInput() {
      this.focusInput(this.activeInput - 1)
    },
    // Change OTP value at focused input
    changeCodeAtFocus(value) {
      this.oldOtp = Object.assign([], this.otp)
      this.$set(this.otp, this.activeInput, value)
      if (this.oldOtp.join('') !== this.otp.join('')) {
        if (!this.otp.join('')) {
          this.otp = []
          this.activeInput = 0
        }
        this.$emit('on-change', this.otp.join(''))
        this.checkFilledAllInputs()
      }
    },

    handleOnFocus(index) {
      this.activeInput = index
    },
    handleOnBlur() {},
    // Handle pasted OTP => not used
    handleOnPaste(event) {
      event.preventDefault()
      const pastedData = event.clipboardData
        .getData('text/plain')
        .slice(0, this.numInputs - this.activeInput)
        .split('')
      if (this.inputType === 'number' && !pastedData.join('').match(/^\d+$/)) {
        return 'Invalid pasted data'
      }
      // Paste data from focused input onwards
      const currentCharsInOtp = this.otp.slice(0, this.activeInput)
      const combinedWithPastedData = currentCharsInOtp.concat(pastedData)
      this.$set(this, 'otp', combinedWithPastedData.slice(0, this.numInputs))
      this.focusInput(combinedWithPastedData.slice(0, this.numInputs).length)
      return this.checkFilledAllInputs()
    },

    // when input is valid (full maxlength) => auto change the focus input
    handleOnChange(value) {
      this.changeCodeAtFocus(value)
      this.focusNextInput()
    },
    // Handle cases of backspace, delete, left arrow, right arrow
    handleOnKeyDown(event) {
      switch (event.keyCode) {
        case BACKSPACE: {
          const t = event.target
          if (!t.value[t.selectionStart - 1]) {
            event.preventDefault()

            if (this.activeInput === 0) {
              this.otp = []
              this.$emit('on-change', this.otp.join(''))
            } else {
              this.changeCodeAtFocus('')
              this.focusPrevInput()
              this.otp.splice(this.activeInput + 1)
            }
          }
          break
        }

        // case DELETE:
        //   event.preventDefault();
        //   this.changeCodeAtFocus('');
        //   break;
        // case LEFT_ARROW:
        //   event.preventDefault();
        //   this.focusPrevInput();
        //   break;
        // case RIGHT_ARROW:
        //   event.preventDefault();
        //   this.focusNextInput();
        //   break;
        default:
          break
      }
    }
  }
}
</script>
